'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentClickandbuyAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M58.2492 17.0739L49.5171 8.37778C49.5171 8.37778 48.3859 7.25 46.7883 7.25C46.7883 7.25 45.1908 7.25 44.0595 8.37778C44.0595 8.37778 42.9283 9.50556 42.9283 11.0984C42.9283 11.0984 42.9283 12.6912 44.0595 13.819L46.183 15.9263H38.0362C38.0362 15.9263 36.4189 15.9263 35.2878 17.0639C35.2878 17.0639 34.1466 18.1917 34.1466 19.7945C34.1466 19.7945 34.1466 21.3971 35.2878 22.5348C35.2878 22.5348 36.4189 23.6626 38.0362 23.6626H46.183L44.0595 25.7797C44.0595 25.7797 42.9283 26.9075 42.9283 28.5003C42.9283 28.5003 42.9283 30.0932 44.0595 31.2211C44.0595 31.2211 45.1907 32.3389 46.7883 32.3389C46.7883 32.3389 48.3857 32.3389 49.5171 31.2211L58.2393 22.5151C58.2393 22.5151 59.3705 21.3873 59.3705 19.7945C59.3705 19.7945 59.3705 18.2016 58.2492 17.0739Z",
          fill: "#FF8000"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M26.8232 14.4324C26.8232 14.4324 28.9567 14.4324 30.465 15.9361C30.465 15.9361 31.9733 17.4398 31.9733 19.5669C31.9733 19.5669 31.9733 21.6939 30.465 23.1977C30.465 23.1977 28.9567 24.7016 26.8232 24.7016C26.8232 24.7016 24.6899 24.7016 23.1815 23.1977C23.1815 23.1977 21.6733 21.694 21.6733 19.5669C21.6733 19.5669 21.6733 17.4398 23.1815 15.9361C23.1817 15.9361 24.6899 14.4324 26.8232 14.4324Z",
          fill: "#FF8000"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.9894 47.0349C12.9894 47.0349 12.2725 47.1749 11.6341 47.1749C9.74897 47.1749 8.68964 46.1496 8.68964 44.2237V42.0493C8.68964 40.1235 9.73339 39.0984 11.6341 39.0984C12.335 39.0984 12.9894 39.2382 12.9894 39.2382C13.1917 39.2694 13.2853 39.3781 13.2853 39.549V40.4962C13.2853 40.6674 13.1762 40.7606 12.9894 40.7447C12.9894 40.7447 12.3193 40.6514 11.7432 40.6514C10.7304 40.6514 10.4034 41.2416 10.4034 42.0803V44.1769C10.4034 45.0472 10.7619 45.6217 11.7587 45.6217C12.3664 45.6217 13.005 45.5285 13.005 45.5285C13.1764 45.513 13.2854 45.5908 13.2854 45.7616V46.7089C13.2853 46.8796 13.2075 46.9883 12.9894 47.0349Z",
          fill: "#FF8000"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.7939 47.0194H14.6721C14.5004 47.0194 14.3759 46.8951 14.3759 46.7243V36.2873C14.3759 36.1158 14.5004 35.9919 14.6721 35.9919H15.7939C15.9651 35.9919 16.0897 36.1158 16.0897 36.2873V46.7243C16.0895 46.8951 15.9651 47.0194 15.7939 47.0194Z",
          fill: "#FF8000"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.8312 47.0194H17.7097C17.5384 47.0194 17.4136 46.8951 17.4136 46.7243V39.5488C17.4136 39.3779 17.5384 39.2535 17.7097 39.2535H18.8312C19.0027 39.2535 19.1275 39.3779 19.1275 39.5488V46.7243C19.1277 46.8951 19.0029 47.0194 18.8312 47.0194ZM18.8312 37.7007H17.7097C17.5384 37.7007 17.4136 37.5764 17.4136 37.4057V36.2873C17.4136 36.1158 17.5384 35.9919 17.7097 35.9919H18.8312C19.0027 35.9919 19.1275 36.1158 19.1275 36.2873V37.4057C19.1277 37.5764 19.0029 37.7007 18.8312 37.7007Z",
          fill: "#FF8000"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M24.751 47.0349C24.751 47.0349 24.0344 47.1749 23.3961 47.1749C21.5108 47.1749 20.4517 46.1496 20.4517 44.2237V42.0493C20.4517 40.1235 21.4953 39.0984 23.3961 39.0984C24.097 39.0984 24.751 39.2382 24.751 39.2382C24.9535 39.2694 25.0471 39.3781 25.0471 39.549V40.4962C25.0471 40.6674 24.9381 40.7606 24.751 40.7447C24.751 40.7447 24.0811 40.6514 23.5047 40.6514C22.4923 40.6514 22.165 41.2416 22.165 42.0803V44.1769C22.165 45.0472 22.5236 45.6217 23.5205 45.6217C24.1279 45.6217 24.7667 45.5285 24.7667 45.5285C24.9379 45.513 25.047 45.5908 25.047 45.7616V46.7089C25.0471 46.8796 24.9691 46.9883 24.751 47.0349Z",
          fill: "#FF8000"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M31.7149 47.0194H30.4529C30.2816 47.0194 30.1416 46.8796 30.0636 46.7243L27.9449 42.6707L29.8765 39.5488C29.9699 39.4087 30.11 39.2535 30.2816 39.2535H31.5437C31.7149 39.2535 31.8082 39.4087 31.7149 39.5488L29.783 42.6394L31.9172 46.7243C31.9953 46.8641 31.8862 47.0194 31.7149 47.0194ZM27.5556 47.0194H26.4338C26.2626 47.0194 26.1376 46.8951 26.1376 46.7243V36.2873C26.1376 36.1158 26.2626 35.9919 26.4338 35.9919H27.5556C27.7268 35.9919 27.8517 36.1158 27.8517 36.2873V46.7243C27.8516 46.8951 27.7268 47.0194 27.5556 47.0194Z",
          fill: "#FF8000"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M36.3418 43.7731H35.0334C34.1922 43.7731 33.8493 44.1305 33.8493 44.7983C33.8493 45.3884 34.1922 45.7302 34.8775 45.7302C35.3604 45.7302 35.8902 45.5439 36.3418 45.3109V43.7731ZM37.7593 47.0194H36.7157C36.5445 47.0194 36.4199 46.8951 36.4199 46.7243V46.5846C35.9212 46.8951 35.2671 47.1748 34.5346 47.1748C33.0238 47.1748 32.1355 46.4135 32.1355 44.8451C32.1355 43.2452 33.1169 42.4532 34.8461 42.4532C35.3761 42.4532 36.1395 42.5149 36.3417 42.5465V41.9251C36.3417 41.1173 35.9834 40.6826 35.0644 40.6826C34.1453 40.6826 32.9766 40.9466 32.9766 40.9466C32.7898 40.9931 32.6807 40.8691 32.6807 40.698V39.7508C32.6807 39.5797 32.7898 39.4713 32.9766 39.4245C32.9766 39.4245 33.9893 39.0985 35.2979 39.0985C37.3699 39.0985 38.0552 40.0615 38.0552 41.9253V46.7244C38.0553 46.8951 37.9307 47.0194 37.7593 47.0194Z",
          fill: "#808080"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M45.0036 47.0194H43.8821C43.7109 47.0194 43.5861 46.8951 43.5861 46.7243V41.8939C43.5861 41.1644 43.3679 40.6978 42.5425 40.6978C42.0596 40.6978 41.5298 40.9154 41.0936 41.1486V46.7243C41.0936 46.8951 40.9691 47.0194 40.7976 47.0194H39.6761C39.5044 47.0194 39.3799 46.8951 39.3799 46.7243V39.5488C39.3799 39.378 39.5044 39.2536 39.6761 39.2536H40.7197C40.8911 39.2536 41.0158 39.378 41.0158 39.5488V39.7819C41.4673 39.4401 42.1372 39.0984 43.0248 39.0984C44.7232 39.0984 45.2994 40.1235 45.2994 41.7388V46.7243C45.2994 46.8951 45.175 47.0194 45.0036 47.0194Z",
          fill: "#808080"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M50.5187 40.9C50.0982 40.7292 49.6308 40.6048 49.2102 40.6048C48.3532 40.6048 48.0263 41.1485 48.0263 41.9251V44.3325C48.0263 45.1091 48.3532 45.6526 49.2102 45.6526C49.6308 45.6526 50.0982 45.4973 50.5187 45.2953V40.9ZM51.9363 47.0194H50.8924C50.721 47.0194 50.5965 46.8951 50.5965 46.7243V46.6314C50.1136 46.9262 49.5218 47.1748 48.8519 47.1748C47.1225 47.1748 46.3126 46.1184 46.3126 44.4566V41.8161C46.3126 40.1542 47.1225 39.0984 48.8519 39.0984C49.4906 39.0984 50.0514 39.2846 50.5188 39.5179V36.2873C50.5188 36.1158 50.6436 35.9919 50.8149 35.9919H51.9364C52.1078 35.9919 52.2326 36.1158 52.2326 36.2873V46.7243C52.2324 46.8951 52.1076 47.0194 51.9363 47.0194Z",
          fill: "#808080"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M57.7629 41.9251C57.7629 41.1487 57.451 40.6048 56.5942 40.6048C56.1736 40.6048 55.6907 40.7604 55.2701 40.9622V45.5439H56.4694C57.4044 45.5439 57.7629 45.0316 57.7629 44.2549V41.9251ZM56.6255 47.0194H53.8527C53.6811 47.0194 53.5566 46.8951 53.5566 46.7243V36.2873C53.5566 36.1158 53.6811 35.9919 53.8527 35.9919H54.9742C55.1457 35.9919 55.2702 36.1158 55.2702 36.2873V39.5795C55.7376 39.3001 56.314 39.0984 56.9527 39.0984C58.6817 39.0984 59.4767 40.1544 59.4767 41.8161V44.3012C59.4765 45.994 58.557 47.0194 56.6255 47.0194Z",
          fill: "#FF8000"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M66.4247 47.0194H65.381C65.2096 47.0194 65.085 46.8951 65.085 46.7243V46.4912C64.6333 46.8333 63.9633 47.1748 63.0754 47.1748C61.3773 47.1748 60.8009 46.1496 60.8009 44.5343V39.5488C60.8009 39.3779 60.9254 39.2535 61.097 39.2535H62.2188C62.3901 39.2535 62.5148 39.3779 62.5148 39.5488V44.3791C62.5148 45.1091 62.7328 45.5748 63.5583 45.5748C64.0411 45.5748 64.5709 45.3578 65.0072 45.1245V39.5488C65.0072 39.3779 65.1319 39.2535 65.3031 39.2535H66.4247C66.5961 39.2535 66.7207 39.3779 66.7207 39.5488V46.7243C66.7207 46.8951 66.5959 47.0194 66.4247 47.0194Z",
          fill: "#FF8000"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M70.8959 49.6908C70.8335 49.8461 70.7401 49.9704 70.5689 49.9704H69.3067C69.1355 49.9704 69.011 49.8306 69.0732 49.6756L69.961 47.0816L67.4839 39.5489C67.4374 39.3939 67.5311 39.2537 67.7179 39.2537H68.9487C69.1199 39.2537 69.2444 39.3627 69.2913 39.5332L70.8804 44.4568L72.5473 39.5332C72.6096 39.3782 72.7187 39.2537 72.89 39.2537H74.1209C74.3077 39.2537 74.4166 39.4088 74.3544 39.5646L70.8959 49.6908Z",
          fill: "#FF8000"
        }
      )
    ]
  }
);
const VpPaymentClickandbuyAsset = forwardRef(PaymentClickandbuyAsset);

export { VpPaymentClickandbuyAsset as default };
